import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import ProductRepository from "../../../repositories/product-repository";
import { ProductList } from "../list/interface";
import { Product } from "../../../models/product";

export const useGetProduct = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<ProductList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [productData, setProductData] = useState<Product | null>(null);
  const [isOnFetchingProductData, setIsOnFetchingProductData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await ProductRepository.all(params)
      .then((response: AxiosResponse<ICollection<ProductList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadProductData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingProductData(true);

      await ProductRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Product>>) => {
          setProductData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingProductData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadProductData,
    isOnFetchingProductData,
    productData,
  };
};
